import { useEffect, useRef, useState } from "react"
import { useTheme } from "@context"
import { Divider } from "@components"
import { decodeToken } from "@helpers"
import { authService } from "@services"
import { Link } from 'react-router-dom'
import { getLinks } from "./data"

const UserMenu = ({ initials }) => {
  const { theme, setTheme } = useTheme()
  const [isOpen, setIsOpen] = useState(false)
  const userMenuRef = useRef(null);
  const userMenuAvatarRef = useRef(null);
  const token = authService.getToken()
  const is365 = decodeToken(token)?.signin_type === "365" ? true : false
  const links = getLinks(theme, setTheme, is365)
  const showLargeMenu = links.length >=6
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if ( 
        userMenuRef.current && !userMenuRef.current.contains(event.target) && userMenuAvatarRef.current && !userMenuAvatarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleToggleMenu = () => {
    setIsOpen((prev) => !prev);
  }

  return (
    <div id="user-menu-avatar" className="relative" ref={userMenuAvatarRef}>
      <button id="user-menu-avatar-button" onClick={() => handleToggleMenu()} className="inline-flex items-center justify-center rounded-full cursor-pointer size-12 hover:bg-top-navbar-avatar-hover bg-top-navbar-avatar">
        <span className="text-lg font-medium text-white">{initials}</span>
      </button>

      <div id="user-menu" ref={userMenuRef} className={`absolute left-1/2 z-40 mt-5 flex w-screen max-w-max translate-x-[calc(-100%+3rem)] px-4 translate-y-1 transition ease-out duration-200 ${!isOpen ? "hidden opacity-0" : ""}`}>
        <div className="px-2 overflow-hidden shadow-lg bg-content1 dark:bg-content2 rounded-2xl">
          <div className={`flex-auto w-screen max-w-md overflow-hidden scrollbar-thin scrollbar-padded overflow-y-auto max-h-[85vh] text-sm/6 ${showLargeMenu ? 'lg:max-w-3xl' : ''}`}>
            <div className={`grid grid-cols-1 p-4 gap-x-6 gap-y-1 ${showLargeMenu ? 'lg:grid-cols-2' : ''}`}>
              {links.map(link => (
                <div 
                  key={link.id} 
                  className={`relative flex p-2 px-4 rounded-lg group gap-x-6 ${!link.isSelected ? 'hover:bg-content3' : ''} ${link.isSelected ? 'bg-content3' : ''}`}
                >
                  <div className={`flex items-center justify-center flex-none mt-1 rounded-lg size-11 ${link.isSelected ? 'bg-content4' : 'bg-content3'} text-content3-foreground group-hover:bg-content4`}>
                    {link.icon}
                  </div>

                  <div>
                    <a href={link.href} target={link.openInNewTab ? '_blank' : '_self'} rel="noopener noreferrer" onClick={link.onClick ? link.onClick : undefined} className="font-semibold foreground">
                      {link.title}
                      <span className="absolute inset-0"></span>
                    </a>
                    <p className="text-content2-foreground">{link.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <Divider className="border-gray-300"/>

            <div className={`flex flex-wrap items-center gap-3 px-8 pt-4 py-6 ${showLargeMenu ? 'lg:flex-nowrap' : ''} bg-content1 dark:bg-content2 rounded-2xl`}>
              <div>
                <div className="flex items-center gap-x-3">
                  <h3 className="font-semibold foreground text-sm/6">Parents Meetings</h3>
                  <p className="rounded-full bg-indigo-700 px-2.5 py-1.5 text-xs font-semibold text-indigo-200">New</p>
                </div>
                
                <p className="mt-2 text-content2-foreground text-sm/6">Welcome to the new version of parents meeting. We'd appreciate your <Link className="font-semibold text-blue-600" to="/feedback">feedback</Link></p>
              </div>
              
              {/* <Button className={`font-semibold text-white ${showLargeMenu ? 'lg:max-w-48' : ''}`} onPress={() => goToOldVersion()} fullWidth color="success">Revert to old version</Button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserMenu